var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar",class:[
        {'navbar-transparent': _vm.transparent},
        {[`bg-${_vm.type}`]: _vm.type}
     ]})
}
var staticRenderFns = []

export { render, staticRenderFns }